<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="streaming" @selected="switchTab"></TabsWidget>
      <div class="tab-options">
        <b-button type="is-primary" outlined @click="newPrice()">NEW
          PRICE</b-button>
      </div>
    </div>
    <div class="wrapper-body">
      <div class="left-panel">
        <div v-if="!loading_pricing && pricing_data.length > 0" class="left-panel">
          <div class="table-widget">
            <table>
              <tr>
                <th>Location</th>
                <th>Price</th>
                <th>Status</th>
                <th></th>
              </tr>
              <tr v-for="(item, index) in pricing_data" :key="index">
                <td>{{ item.location_name }}</td>
                <td>
                  {{
                    `${$validateCurrencyLabel(item.currency)} ${item.amount}`
                  }}
                </td>
                <td>
                  <b-tag v-if="item.status == 'published'" type="is-success">Published</b-tag>
                  <b-tag v-if="item.status == 'pending'" type="is-warning">Draft</b-tag>
                </td>
                <td>
                  <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                    <template #trigger>
                      <b-icon icon="dots-vertical"></b-icon>
                    </template>
                    <b-dropdown-item @click="updatePrice(item)" aria-role="listitem">Update</b-dropdown-item>
                    <b-dropdown-item @click="deletPrice(item.id, index)" aria-role="listitem">Delete</b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div v-if="loading_pricing" class="left-panel">
          <div class="table-widget">
            <table>
              <tr>
                <th>Price</th>
                <th>Location</th>
                <th>Days</th>
                <th>Status</th>
                <th></th>
              </tr>
              <tr v-for="(item, index) in 15" :key="index">
                <td><b-skeleton width="90%"></b-skeleton></td>
                <td><b-skeleton width="90%"></b-skeleton></td>
                <td><b-skeleton width="90%"></b-skeleton></td>
                <td><b-skeleton width="90%"></b-skeleton></td>
                <td><b-skeleton width="90%"></b-skeleton></td>
              </tr>
            </table>
          </div>
        </div>
        <div v-if="!loading_pricing && pricing_data.length == 0" class="left-panel">
          <widgetNotfound title="No Pricing Found" subtitle="You have not created any pricing yet."></widgetNotfound>
        </div>
      </div>
      <div class="rigth-panel"></div>
    </div>

    <!-- Add Price Modal -->
    <addPricingModal v-if="show_pricing_modal" @close="show_pricing_modal = false" :content="selected_item"
      :type="pricing_type" @success="onAddPriceSuccess()"></addPricingModal>
  </div>
</template>

<script>
import addPricingModal from "./components/add_pricing_modal.vue";
import TabsWidget from "./components/TabsWidget.vue";
export default {
  components: {
    addPricingModal,
    TabsWidget,
  },
  sockets: {},
  data: () => ({
    pricing_type: "streaming",
    loading_pricing: false,
    show_pricing_modal: false,
    pricing_data: [],
    selected_item: null,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getAllPrice();
  },
  methods: {
    deletPrice(id, index) {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.$store
              .dispatch("PRICING_DELETE_PRICING", { id: id })
              .then((response) => {
                vm.pricing_data.splice(index, 1);
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: response.data.message,
                });
              });
          }
        },
      });
    },
    updatePrice(item) {
      let vm = this;
      vm.selected_item = item;
      vm.show_pricing_modal = true;
    },
    getAllPrice() {
      let vm = this;
      vm.$store
        .dispatch("PRICING_GET_PRICING", {
          type: vm.pricing_type,
        })
        .then((response) => {
          vm.pricing_data = response.data.return;
        })
        .catch(({ response }) => { });
    },
    onAddPriceSuccess() {
      let vm = this;
      vm.show_pricing_modal = false;
      vm.getAllPrice();
    },
    newPrice() {
      let vm = this;
      vm.selected_item = null;
      vm.show_pricing_modal = true;
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: flex;
    justify-content: center;
    align-items: center;

    .left-panel {
      height: 100%;
      width: calc(100% - 0px);
      background: #fff;
      overflow-y: auto;

      .table-widget {
        height: calc(100% - 60px);
        overflow-y: auto;

        table {
          width: 100%;

          tr {
            th {
              white-space: nowrap;
            }

            td {
              white-space: nowrap;

              .tag-lists {
                display: flex;
                width: fit-content;
                flex-shrink: 0;
                min-width: 170px;
              }
            }
          }
        }
      }
    }

    .rigth-panel {
      width: 0px;
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      display: flex;
      flex-direction: column;

      .right-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0px 10px;
        border-bottom: 1px solid #ddd;
      }
    }
  }
}</style>
